import React from 'react';
import { Link } from 'react-router-dom';
import './App.css'

const Navbar = ({ cartSize }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top" > {/* Add fixed-top class */}
      <div className="container-fluid">
        {/* Logo */}
        <div className="navbar-brand    mx-5" >
          <Link to="/" style={{ color: 'black',textDecoration:"none",backgroundColor:"#ffcc00",padding:"3% 45% 3% 45%",borderRadius:"10px" }}>
            Mobile Store
          </Link>
        </div>

        {/* Toggler button for small screens */}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <div className="navbar-text">
            <Link className="nav-link text-light d-lg-none" to="/cart">
              <i className="fa fa-shopping-cart" style={{ color: 'yellow', marginRight: '5px' }}></i>
              Cart ({cartSize})
            </Link>
          </div>
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible content */}
        <div className="collapse navbar-collapse" id="navbarNav">
        
          <ul className="navbar-nav mx-auto"> {/* mx-auto for centering */}
            {/* Other navigation links */}
            <li className="nav-item">
              <Link className="nav-link text-light" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/products">
                Products
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/contact">
                Contact
              </Link>
            </li>
            <li className="nav-item ">
              <Link className="nav-link text-light " to="/login">
                Login
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light " to="/signup">
                Signup
              </Link>
            </li>
          </ul>

          {/* Cart link */}
          <div className="navbar-text">
            <Link className="nav-link text-light " to="/cart">
              <i className="fa fa-shopping-cart" style={{ color: 'yellow', marginRight: '5px' }}> Cart</i>
              <span class="badge badge-danger">{cartSize}</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
